import apiClient from '@/services/InvoiceapiClient'
export default {
    postBankAccount(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/banking/create', data)
    },
    updateBankAccount (data, id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/banking/update/' + id, data)
    },
    getBankingDetails ( token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/banking/details/')
    },
    fetchBankingList (page,show, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/banking/index/'+page+'/'+show)
    },
    fetchBankingData (id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/banking/view/'+id)
    },
    postBankingdelete(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/banking/delete', id)
    },
    postBankingstatus(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/banking/activeStatusChange ', data)
    },
}